var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCcfoliaPro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 14,
    viewBox: "0 0 126.68 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "PRO") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m88.04,12.11c-5,0-8.64,3.87-8.64,8.91s3.68,8.91,8.64,8.91,8.68-3.83,8.68-8.91-3.87-8.91-8.68-8.91Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m59.62,12.26h-4.74v8.41h4.74c3.52,0,5.42-1.67,5.42-4.24s-1.89-4.17-5.42-4.17Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m114.58,16.59h3.49s.02,0,.02,0c4.74,0,8.58-3.71,8.58-8.29S122.84,0,118.1,0c0,0-.02,0-.02,0h0s-5.63,0-5.63,0H13.46c-3.91,0-7.25,2.98-7.91,7.07L0,41.37h37.66v.02s75.81,0,75.81,0h0c2.81,0,5.09-2.07,5.09-4.62s-2.28-4.62-5.09-4.62h0s-.89,0-.89,0c-.83,0-1.5-.67-1.5-1.5s.67-1.5,1.5-1.5h4.68c2.73,0,4.95-2.14,4.95-4.78s-2.2-4.77-4.93-4.78h-2.7c-.83,0-1.5-.67-1.5-1.5s.67-1.5,1.5-1.5Zm-80.04,8.93h-4.06v8.75h-5.27V7.75h9.32c6.33,0,10.54,3.68,10.54,8.87s-4.21,8.91-10.54,8.91Zm30.85,8.75l-.68-4.47c-.57-3.45-2.8-5-5.42-5h-4.4v9.47h-5.27V7.75h10.65c6.33,0,10.12,3.41,10.12,8.6,0,3.03-1.63,5.46-4.24,6.67,1.59.95,3.34,2.99,3.87,6.44l.76,4.81h-5.38Zm22.65.45c-8,0-14.02-5.84-14.02-13.72s6.14-13.72,14.02-13.72,14.06,5.84,14.06,13.72-6.22,13.72-14.06,13.72Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m34.08,12.26h-3.6v8.87h3.6c3.37.04,5.61-1.55,5.61-4.43s-2.24-4.43-5.61-4.43Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCcfoliaPro);
export default __webpack_public_path__ + "static/media/CcfoliaPro.6c27faba80e774617740afc105a1efd7.svg";
export { ForwardRef as ReactComponent };